import React from 'react';
import { changeLanguage, t } from 'i18next';
import slovakFlag from '../../../../images/sk.webp';
import hungarianFlag from '../../../../images/hu.webp';
import englishFlag from '../../../../images/gb.webp';
import fb from '../../../../images/fb.svg';
import instagram from '../../../../images/instagram.svg';
import { EN, HU, SK } from '../../../../constants/languages';
import { getLanguage, setLanguage } from '../../../../shared/providers/languageProvider';
import { Language } from '../../../../types/language';
import './Header.scss';
import { getAppendedClassWithDevice } from '../../../../shared/utils/deviceUtils';
import { facebookUri } from './constants';

interface HeaderProp {
    isMobile?: boolean;
}

export const Header = (prop: HeaderProp = {
    isMobile: false
}) => {
    const switchLanguage = (language: string) => {
        const lng: Language = getLanguage(language);

        setLanguage(lng.id);
        changeLanguage(lng.id).then(() => {
            window.location.reload();
        });
    };

    return (
        <header className={getAppendedClassWithDevice('header', prop.isMobile)}>
            <div className={getAppendedClassWithDevice('action-bar', prop.isMobile)}>
                <div className={getAppendedClassWithDevice('location', prop.isMobile)}>
                    {t("Location")}
                </div>
                <div className={getAppendedClassWithDevice('d-flex actions-container', prop.isMobile)}>
                    <div className="social">
                        <div className="social-link">
                            <a href={facebookUri}>
                                <img alt="fb" src={fb} />
                            </a>
                        </div>
                        <div className="social-link">
                            <img alt="instagram" src={instagram} />
                        </div>
                    </div>
                    <div className="languages">
                        <div className="lang" onClick={() => switchLanguage(SK)}>
                            <img src={slovakFlag} alt="slovak_flag" />
                        </div>
                        <div className="lang" onClick={() => switchLanguage(HU)}>
                            <img src={hungarianFlag} alt="hungarian_flag" />
                        </div>
                        <div className="lang" onClick={() => switchLanguage(EN)}>
                            <img src={englishFlag} alt="english_flag" />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};
